class ReviewModal extends HTMLElement {
  constructor() {
    super();
    this.modal = null;
    this.boundKeyHandler = this.handleKeyDown.bind(this);
  }

  connectedCallback() {
    this.modal = this.querySelector('.review-modal');
    this.setupEventListeners();
  }

  setupEventListeners() {
    const closeBtn = this.querySelector('.review-modal__close');
    const backdrop = this.querySelector('.review-modal__backdrop');

    if (closeBtn) {
      closeBtn.addEventListener('click', () => this.close());
    }

    if (backdrop) {
      backdrop.addEventListener('click', () => this.close());
    }
  }

  open(reviewData) {
    if (!this.modal) return;

    this.updateStars(reviewData.stars);
    this.querySelector('.review-modal__text').innerHTML = reviewData.text;
    this.querySelector('.review-modal__name').textContent = reviewData.name;

    const dateEl = this.querySelector('.review-modal__date');
    if (reviewData.date) {
      dateEl.textContent = reviewData.date;
      dateEl.style.display = '';
    } else {
      dateEl.style.display = 'none';
    }

    const imageEl = this.querySelector('.review-modal__image');
    if (reviewData.image) {
      imageEl.innerHTML = `<img src="${reviewData.image}" alt="${reviewData.name}" width="48" height="48">`;
      imageEl.classList.remove('review-modal__image--placeholder');
    } else {
      imageEl.innerHTML = reviewData.name.charAt(0);
      imageEl.classList.add('review-modal__image--placeholder');
    }

    this.modal.classList.add('review-modal--open');
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', this.boundKeyHandler);

    const closeBtn = this.querySelector('.review-modal__close');
    if (closeBtn) closeBtn.focus();
  }

  close() {
    if (!this.modal) return;

    this.modal.classList.remove('review-modal--open');
    document.body.style.overflow = '';
    document.removeEventListener('keydown', this.boundKeyHandler);
  }

  handleKeyDown(e) {
    if (e.key === 'Escape') {
      this.close();
    }
  }

  updateStars(count) {
    const stars = this.querySelectorAll('.review-modal__star');
    stars.forEach((star) => {
      const starNum = parseInt(star.dataset.star);
      if (starNum > count) {
        star.classList.add('review-modal__star--empty');
      } else {
        star.classList.remove('review-modal__star--empty');
      }
    });
  }
}

if (!customElements.get('review-modal')) {
  customElements.define('review-modal', ReviewModal);
}

window.openReviewModal = function(button) {
  const card = button.closest('.review-card');
  const modal = document.querySelector('review-modal');

  if (!card || !modal) return;

  const reviewData = {
    stars: parseInt(card.dataset.stars) || 5,
    text: card.dataset.fullText || '',
    name: card.dataset.reviewerName || '',
    date: card.dataset.reviewerDate || '',
    image: card.dataset.reviewerImage || ''
  };

  modal.open(reviewData);
};
